enum OperationType {
  Mutation = "mutation",
  Query = "query",
  Subscription = "subscription",
}

export default OperationType;
